<template>
  <b-modal
    id="feed-modal"
    :visible="show"
    header-class="my-class"
    content-class="modal-insta "
    :hide-footer="true"
    :no-fade="true"
    :no-close-on-backdrop="true"
    :centered="true"
    size="xl"
    v-on:show="setupSwiper"
    v-on:shown="initSwiper()"
    v-on:hidden="destroySwiper"
    v-cloak
  >
    <div class="row" v-cloak>
      <div class="col-md-12">
        <div class="swiper-container">
          <!-- Slider main container -->
          <div class="swiper swiper-insta">
            <!-- Additional required wrapper -->
            <div
              class="swiper-wrapper"
              v-bind:style="{ visibility: showSwiper ? 'visible' : 'hidden' }"
            >
              <!-- Slides -->
              <div
                class="swiper-slide"
                v-for="(f, index) in feeds"
                v-bind:key="f.id"
              >
                <div class="row m-0" style="height: 100%">
                  <div
                    class="col-md-7 p-0 position-relative"
                    style="overflow: hidden"
                  >
                    <template v-if="f.mediaType == 'IMAGE'">
                      <img
                        v-bind:src="f.mediaUrl"
                        class="img-fluid w-100 rounded"
                        data-width="1080"
                        data-height="1080"
                      />
                    </template>

                    <template v-if="f.mediaType == 'VIDEO'">
                      <video
                        v-bind:id="'video-' + index"
                        v-bind:src="f.mediaUrl"
                        v-bind:poster="f.thumbnail"
                        controls
                        controlsList="nodownload"
                        preload="none"
                      ></video>
                    </template>

                    <template v-if="f.mediaType == 'CAROUSEL_ALBUM'">
                      <div
                        class="loader loader-no-overlay"
                        v-if="!f.children.loaded"
                      >
                        <div class="loaderinner"></div>
                      </div>

                      <div
                        v-bind:class="'inner-swiper-carousel-' + index"
                        v-if="f.children.loaded"
                      >
                        <div class="swiper-wrapper">
                          <div
                            class="swiper-slide"
                            v-for="item in f.children.items"
                            v-bind:key="item.id"
                          >
                            <img
                              v-bind:src="item.mediaUrl"
                              class="img-fluid w-100 rounded"
                            />
                          </div>
                        </div>

                        <div
                          class="swiper-button-prev"
                          v-bind:class="'inner-swiper-button-prev-' + index"
                        ></div>
                        <div
                          class="swiper-button-next"
                          v-bind:class="'inner-swiper-button-next-' + index"
                        ></div>
                      </div>
                    </template>
                  </div>

                  <div class="col-md-5 p-0">
                    <div class="insta-info mt-3">
                      <strong class="d-block">{{ f.owner }}</strong>
                      <div class="clearfix"></div>
                      <small>{{
                        f.created | formatDate("MMMM DD, YYYY")
                      }}</small>
                    </div>

                    <div class="mt-2">
                      <p
                        class="insta-description"
                        style="overflow-x: hidden; overflow-y: auto !important"
                        v-html="f.caption"
                      ></p>
                    </div>
                  </div>
                </div>
              </div>
              ...
            </div>

            <!-- If we need navigation buttons -->
          </div>

          <div class="swiper-button-prev swiper-button-prev-main"></div>

          <div class="swiper-button-next swiper-button-next-main"></div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import "swiper/css";
import "swiper/css/navigation";
import "bootstrap-vue/dist/bootstrap-vue.css";

import Vue from "vue";
import axios from "axios";
import { ModalPlugin } from "bootstrap-vue";
import Swiper, { Navigation } from "swiper";
import "../../../superadmin/filters/format-date";

Vue.use(ModalPlugin);

export default {
  props: ["feeds", "selectedFeedItemIndex", "show"],

  data() {
    return {
      innerSwipers: [],
      showSwiper: false,
      swiper: undefined,
    };
  },

  methods: {
    destroySwiper() {
      this.showSwiper = false;

      //destroy main swiper instance
      this.swiper.destroy();

      //destroy all inner swipers instance
      this.innerSwipers.forEach((iSwiper, index) => iSwiper.destroy());

      this.innerSwipers.length = 0;

      //emit event to the parent
      this.$emit("update:show", false);
    },

    loadMediaChildren(media, mediaSlideIndex) {
      if (media.children.loaded) {
        this.setupInnerSwiper(mediaSlideIndex);
        return;
      }

      let url = "/api/social/insta/media/children";
      return axios.post(url, media.children).then((res) => {
        media.children.loaded = true;
        media.children.items = res.data.result;
        this.setupInnerSwiper(mediaSlideIndex);
      });
    },

    initSwiper(swiper) {
      if (!swiper) {
        this.swiper.init();
        return;
      }

      setTimeout(() => {
        swiper.init();
        this.innerSwipers.push(swiper);
      }, 200);
    },

    setupSwiper() {
      this.swiper = new Swiper(".swiper", {
        init: false,
        initialSlide: this.selectedFeedItemIndex,

        // configure Swiper to use modules

        modules: [Navigation],

        // Navigation arrows
        navigation: {
          nextEl: ".swiper-button-next-main",
          prevEl: ".swiper-button-prev-main",
        },

        //register event handlers
        on: {
          afterInit: (swiper) => {
            setTimeout(() => {
              this.showSwiper = true;

              let feedItem = this.getFeedItemByIndex(swiper.activeIndex);

              if (feedItem && feedItem.mediaType == "CAROUSEL_ALBUM")
                this.loadMediaChildren(feedItem, swiper.activeIndex);
            }, 1000);
          },

          slidePrevTransitionStart: (swiper) => {
            this.pauseVideoOnSlide(swiper.previousIndex);

            let feedItem = this.getFeedItemByIndex(swiper.activeIndex);

            if (feedItem && feedItem.mediaType == "CAROUSEL_ALBUM")
              this.loadMediaChildren(feedItem, swiper.activeIndex);
          },

          slideNextTransitionStart: (swiper) => {
            this.pauseVideoOnSlide(swiper.previousIndex);

            let feedItem = this.getFeedItemByIndex(swiper.activeIndex);

            if (feedItem && feedItem.mediaType == "CAROUSEL_ALBUM")
              this.loadMediaChildren(feedItem, swiper.activeIndex);
          },
        },
      });
    },

    setupInnerSwiper(index) {
      let innerSwiperElemClass = `.inner-swiper-carousel-${index}`;
      let innerSwiperPrevElemClass = `.inner-swiper-button-prev-${index}`;
      let innerSwiperNextElemClass = `.inner-swiper-button-next-${index}`;

      var swiperAlreadyInitialized = this.innerSwipers.filter(
        (iSwipper) => iSwipper.passedParams.el == innerSwiperElemClass
      )[0];

      if (swiperAlreadyInitialized) return;

      var innerSwiper = new Swiper(innerSwiperElemClass, {
        init: false,
        nested: true,

        // configure Swiper to use modules

        modules: [Navigation],

        // Navigation arrows
        navigation: {
          nextEl: innerSwiperNextElemClass,
          prevEl: innerSwiperPrevElemClass,
        },
      });

      this.initSwiper(innerSwiper);
    },

    /* start- internal methods */

    getFeedItemByIndex(index) {
      return this.feeds.filter((f, i) => i == index)[0];
    },

    pauseVideoOnSlide(slideIndex) {
      let videoElemId = `video-${slideIndex}`;
      let video = document.getElementById(videoElemId);

      if (video) video.pause();
    },

    /* end- internal methods */
  },
};
</script>
